import { useEffect } from 'react';

import { toast } from '@gitbook/spine-react';

import { NavigationRedirect } from '../../navigation';

/**
 * Display a toast error and redirect to the home screen.
 */
export function OrganizationMissingPermRedirect(props: { title?: string; organizationId: string }) {
    const { title = 'Error while accessing', organizationId } = props;

    useEffect(() => {
        toast.error(title, null, {
            description: 'You do not have the required permissions in this organization.',
        });
    }, [title]);

    return (
        <NavigationRedirect
            to={{ screen: { type: 'home', organization: organizationId } }}
            replace
        />
    );
}
